import { defineNuxtPlugin, useNuxtApp } from '#app'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.config.errorHandler = (error) => {
    const { $sentryCaptureException }: any = useNuxtApp()

    console.error(error)

    $sentryCaptureException(error)
  }
})
